import { Check, ChevronDown, X } from "lucide-react";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "@/components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useMemo, useState } from "react";
import { cn } from "@/lib/utils";
import { ConditionRenderer } from "./condition-renderer";
import { GenericType } from "@/types";
import { useLocation } from "react-router-dom";
import { HIDE_FILTER } from "@/global-data/global-const";

export const CustomReactTableHeader = ({
  header,
  table,
  filter,
  setFilter,
  children,
  bindLabel,
  bindValue,
  isHide,
  filterRequest,
}: GenericType) => {
  const [open, setOpen] = useState(false);

  const activeData = filter?.[header] || [];

  const onChange = (prop: string) => {
    let tempArray = activeData;
    if (activeData.includes(prop)) {
      tempArray = activeData.filter((item: string) => item !== prop);
    } else {
      tempArray.push(prop);
    }
    setFilter({ ...filter, [header]: tempArray });
  };

  const clearSelection = () => {
    const newFilter = filter;
    delete newFilter[header];
    setFilter(newFilter);
    setOpen(false);
    filterRequest();
  };

  const location = useLocation();
  const { pathname } = location;

  const isFilterPage = useMemo(() => {
    return !HIDE_FILTER.includes(pathname);
  }, [pathname]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild className={isHide ? "pointer-events-none" : ""}>
        <span className="flex items-center gap-1 w-full pr-3">
          {children}
          <ConditionRenderer condition={activeData?.length !== 0}>
            <>
              <span>({activeData?.length})</span>
              <button className="" onClick={clearSelection}>
                <X size={15} />
              </button>
            </>
          </ConditionRenderer>
          <ConditionRenderer condition={!isHide && isFilterPage}>
            <ChevronDown size={18} />
          </ConditionRenderer>
        </span>
      </PopoverTrigger>
      <PopoverContent
        className={cn("w-[250px] p-0 ml-[-20px]", !isFilterPage && "hidden")}
        align="start"
      >
        <Command>
          <CommandInput placeholder="Search Options..." />
          <CommandList>
            <CommandEmpty>No option found.</CommandEmpty>
            <CommandGroup>
              {table.map((item: GenericType) => (
                <CommandItem
                  key={item?.[bindValue]}
                  value={item?.[bindLabel]}
                  onSelect={() => {
                    onChange(item?.[bindValue]);
                  }}
                >
                  <span className="border min-h-6 min-w-6 rounded-sm  inline-flex items-center justify-center">
                    <Check
                      className={cn(
                        activeData.includes(item?.[bindValue])
                          ? "opacity-100"
                          : "opacity-0"
                      )}
                    />
                  </span>

                  {item?.[bindLabel]}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
